import { render, staticRenderFns } from "./MultipleCardsEdit.vue?vue&type=template&id=475b7ddd&"
import script from "./MultipleCardsEdit.vue?vue&type=script&lang=js&"
export * from "./MultipleCardsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports